import { forwardRef, useMemo } from "react";

import ButtonGroupContainer from "NavBar/components/FloatingButtonPanel/ButtonGroupContainer";
import { delayIn } from "NavBar/components/FloatingButtonPanel/constants";
import {
  navSectionKeys,
  useActiveSectionKey,
  useIsInitialized,
  useNavBarIsFullyLoaded,
} from "NavBar/navBarStore";

import FnrOpacityToggle from "UI/FnrOpacityToggle";
import FnrSlides from "UI/FnrSlides";

import { useActiveSignups, useHasActiveSignups } from "../API/queryHooks";

import AllButton from "./AllButton";
import NewButton from "./NewButton";
import SearchButton from "./SearchButton";

const searchComponents = [
  { value: SearchButton, key: "search" },
  { value: () => null, key: "nothing" },
];

const FloatingButtonPanel = forwardRef((props, ref) => {
  const [activeSectionKey] = useActiveSectionKey();
  const isInitialized = useIsInitialized();
  const isFullyLoaded = useNavBarIsFullyLoaded();
  const activeSignups = useActiveSignups();
  const hasSignups = useHasActiveSignups();

  const isSignupsActive = useMemo(
    () => activeSectionKey === navSectionKeys.signups,
    [activeSectionKey]
  );

  const showSearchButton = useMemo(
    () => activeSignups.length >= 2,
    [activeSignups.length]
  );

  return (
    <FnrOpacityToggle
      show={isSignupsActive && hasSignups && isInitialized && isFullyLoaded}
      delayIn={delayIn}
    >
      <ButtonGroupContainer ref={ref} gap={showSearchButton ? 8 : 4}>
        <AllButton />
        <FnrSlides
          components={searchComponents}
          activeKey={showSearchButton ? "search" : "nothing"}
          variant="fade"
          fullWidth
          clip={false}
        />
        <NewButton />
      </ButtonGroupContainer>
    </FnrOpacityToggle>
  );
});

export default FloatingButtonPanel;
